import { createContext } from 'react'
import createBrowserHistory from 'history/createBrowserHistory'

export const HistoryContext = createContext(null)
// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
export default process.env.BROWSER && createBrowserHistory()
